import React, { useEffect, useContext } from "react";
import { createContext, FunctionComponent, useState } from "react";

//Custom
import UserContext from "@/components/UserContext/UserContext";
import OperationsContext from "./OperationsContext";
import { Permissions as P } from "@/lib/permissions";

import modelProjekti from "@/models/project";
import modelFishnets from "@/models/fishnets";
import dataController from "@/lib/dataController";

//Types
import { DCRecord } from "@/@types/lib/dataController";
import { PickerItem } from "@/@types/controls/controls";
import { UserContextType } from "@/@types/context/UserContext";


const OperationsProvider: FunctionComponent<{}> = (props) => {
  const userContext = useContext(UserContext) as UserContextType;

  const [projects, setProjects] = useState<Array<DCRecord>>([]);
  const [projectItems, setProjectItems] = useState<Array<PickerItem>>([]);
  const [selectedProject, setSelectedProject] = useState<DCRecord | null>(null);

  const [fishnets, setFishnets] = useState<Array<DCRecord>>([]);
  const [fishnetItems, setFishnetItems] = useState<Array<PickerItem>>([]);
  const [selectedFishnet, setSelectedFishnet] = useState<DCRecord | null>(null);

  const dcProjects = new dataController(modelProjekti, "operations/projekti/"); // TODO: Move these endpoints under project router
  const dcFishnets = new dataController(modelFishnets);

  useEffect(() => {
    return () => {
      console.log('reseting Operations Context');
      clearFishnets();
      clearProjects();
    }
  }, [])

  useEffect(() => {
    if (userContext.loaded && userContext.hasAnyPermission([P.Operations])) {
      loadProjects();
    }
  }, [userContext.loaded, userContext.userId])

  const loadProjects = () => {

    dcProjects.GetData().then((resp) => {
      if (resp.success) {
        if (Array.isArray(resp.data) && resp.data.length > 0) {
          const projectPickerItems = resp.data.map(x => { return {label: x.naziv, value: x.id} as PickerItem})
          setProjects(resp.data);
          setProjectItems(projectPickerItems);
        }
      }
    })
  };

  const loadFishnets = (projectId: number | null) => {
    if (projectId) {

      const url = `operations/projekti/${projectId}/fishnets/`

      dcFishnets.GetData(url).then((resp) => {
        if (resp.success) {
          if (Array.isArray(resp.data) && resp.data.length > 0) {
            const fishnetPickerItems = resp.data.map(x => { return { label: x.sifra, value: x.id} as PickerItem});
            setFishnets(resp.data);
            setFishnetItems(fishnetPickerItems);
            if (selectedFishnet !== null) {
              setSelectedFishnet(null);
            }
          }
        }
      })
    } else {
      clearFishnets();
    }
  }

  const clearProjects = () => {
    setProjects([]);
    setProjectItems([]);
    setSelectedProject(null);
  }

  const clearFishnets = () => {
    setFishnets([]);
    setFishnetItems([]);
    setSelectedFishnet(null);
  }

  const selectProject = (id: number | null) => {
    if (id) {
      const p = projects.find(x => x.id === id);
      if (p) {
        setSelectedProject(p);
        loadFishnets(p.id as number);
      } else {
        setSelectedProject(null);
        clearFishnets();
      }
    } else {
      setSelectedProject(null);
      clearFishnets();
    }
  }

  const selectFishnet = (id: number | null) => {
    if (id) {
      const f = fishnets.find(x => x.id === id);
      if (f) {
        setSelectedFishnet(f);
      } else {
        setSelectedFishnet(null);
      }
    } else {
      setSelectedFishnet(null);
    }
  }


  const providerValue = {
    projectItems,
    selectedProject,
    selectProject,

    fishnetItems,
    selectedFishnet,
    selectFishnet
  }

  return (
    <OperationsContext.Provider value={providerValue}>
      {props.children}
    </OperationsContext.Provider>
  );
}

export default OperationsProvider;